import AbstractEntity from "../AbstractEntity";

export default class Suggestion extends AbstractEntity {
    static STATUS_PROPOSED = 0;
    static STATUS_ACCEPTED = 1;
    static STATUS_REFUSED = 2;
    static STATUS_CLOSED = 3;

    static CREATED_BY_CALL_CENTER = 0;
    static CREATED_BY_FFG = 1;
    static CREATED_BY_ATTRIBUTION_ENGINE = 2;

    _id;
    _status;
    _companyId;
    _artisanId;
    _token;
    _refusedReason;
    _createdBy;
    _createdAt;
    _orderId;
    _b2cOrderId;
    _b2csduOrderId;
    _insuranceOrderId;


    getId() {
        return this._id;
    }

    getStatus() {
        return this._status;
    }

    getCompanyId() {
        return this._companyId;
    }

    getArtisanId() {
        return this._artisanId;
    }

    getToken() {
        return this._token;
    }

    getRefusedReason() {
        return this._refusedReason;
    }

    getCreatedBy() {
        return this._createdBy;
    }

    getCreatedAt() {
        return this._createdAt;
    }

    getOrderId() {
        return this._orderId;
    }

    getB2cOrderId() {
        return this._b2cOrderId;
    }

    getB2csduOrderId() {
        return this._b2csduOrderId;
    }

    getInsuranceOrderId() {
        return this._insuranceOrderId;
    }

    getClassName() {
        return "suggestion";
    }
}